
import { CheckCircle, Circle, Clock } from "lucide-react";

interface Step {
  id: string;
  title: string;
  description: string;
  completed: boolean;
  current?: boolean;
}

interface ProgressIndicatorProps {
  steps: Step[];
}

export function ProgressIndicator({ steps }: ProgressIndicatorProps) {
  const completedSteps = steps.filter(step => step.completed).length;
  const progressPercentage = (completedSteps / steps.length) * 100;

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Your Progress</h3>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-cso-600 h-2 rounded-full transition-all duration-300"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
        <p className="text-sm text-gray-600 mt-1">
          {completedSteps} of {steps.length} steps completed ({Math.round(progressPercentage)}%)
        </p>
      </div>

      <div className="space-y-3">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              {step.completed ? (
                <CheckCircle className="h-5 w-5 text-green-500" />
              ) : step.current ? (
                <Clock className="h-5 w-5 text-cso-600" />
              ) : (
                <Circle className="h-5 w-5 text-gray-300" />
              )}
            </div>
            <div className={`${step.completed ? 'text-gray-900' : step.current ? 'text-cso-600' : 'text-gray-400'}`}>
              <h4 className="font-medium">{step.title}</h4>
              <p className="text-sm">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
